import BarChart from './charts/BarChart';
import PieChart from './charts/PieChart';
import styles from "./analytics.module.scss";
import { Info } from "lucide-react";

const CHART_COMPONENTS = {
    // Clé : Nom du composant React
    'barChart': BarChart,
    'pieChart': PieChart,

    // Ajoutez les futurs types ici :
    // 'heatmap': HeatmapChart,
    // 'radar': RadarChart,
    // 'twoLevelPie': TwoLevelPieChart,
    //   ...
};

function ChartContainer({ label, data, info, config, type, isLoading }) {
    const ChartComponent = CHART_COMPONENTS[type];

    if (!data || !data.labels || !data.datasets?.length || !data.labels.length) {
        return (
            <div className={styles.chartContainer}>
                <div className={styles.top}>
                    <p className={styles.label}>{label}</p>
                </div>
                <div className={styles.emptyContainer}>
                    <div className={styles.empty}>
                        Aucune donnée disponible pour ce graphique.
                    </div>
                </div>
            </div>
        );
    }

    if (!ChartComponent) {
        console.warn(`Le type de graphique "${type}" n'est pas configuré.`);
        return (
            <div className={styles.chartContainer}>
                <div className={styles.top}>
                    <p className={styles.label}>{label}</p>
                </div>
                <div className={styles.loadingContainer}>
                    <div className={styles.error}>
                        Configuration manquante pour ce graphique.
                    </div>
                </div>
            </div>
        );
    }
    if (isLoading) {
        return (
            <div className={styles.chartContainer}>
                <div className={styles.top}>
                    <p className={styles.label}>{label}</p>
                </div>
                <div className={styles.loadingContainer}>
                    <div className="w-8 h-8 border-4 border-slate-300 border-t-blue-500 rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }
    return (
        <div className={styles.chartContainer}>
            <div className={styles.top}>
                <p className={styles.label}>{label}</p>
                {info &&
                    <div className={styles.infoContainer}>
                        <Info className={styles.icon} />
                        <p className={styles.tooltip}>{info}</p>
                    </div>}
            </div>
            <ChartComponent data={data} config={config} />
        </div>
    );
}

export default ChartContainer;

